module.exports = __webpack_public_path__ + "static/media/w (8).a26dbd90.jpg";